import React, { Component } from 'react';
import { Button, Form, FormGroup, Modal, Row, Col, Container } from 'react-bootstrap';
import { Snackbar } from '@mui/material';
import { IconButton } from '@mui/material';
import StudentService from '../services/StudentService';






export class AddStudent extends Component {

    emptyItem = {
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        zipCode: '',
        city: '',
        id: ''
    };


    constructor(props) {
        super(props);
        this.state = {
            item: this.emptyItem,
            snackbaropen: false,
        };
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        //this.handleContractChange = this.handleContractChange.bind(this);
    }




    componentDidUpdate(previousProps, currentState) {
        //console.log('In add student :::');
        //console.log(this.props.currentcontract);
        if (previousProps.currentstudent !== this.props.currentstudent) {

            this.setState({ item: this.props.currentstudent });
        }
    }




    handleChange(event) {
        //console.log('In add student handleStudentChange :::');
        //console.log(event);
        const target = event.target;
        const value = target.value;
        const name = target.name;
        let item = { ...this.state.item };
        item[name] = value;
        this.setState({ item });
        //console.log('State after change');
        //console.log(item);
    }
    /*
        handleContractChange(event) {
            //console.log('In add student handleContractChange :::');
            //console.log(event);
            const target = event.target;
            const value = target.value;
            const name = target.name;
            let item = { ...this.state.item };
            item[name] = value;
            this.setState({ item });
            //console.log('State after change');
            //console.log(item);
        }
    */

    handleSubmit(event) {
        event.preventDefault();
        // console.log('Submit contract');
        //console.log(event);
        const { refreshParentStudent,  ...rest } = this.props;
        const { item } = this.state;
        if (item.id) {
            //console.log('Updddddddddaaaaaaate id = ' + item.id);
            //console.log(event);
            StudentService.update(item.id, event)
                .then((response) => {
                    const { message } = response.data;
                    //alert(message)
                    this.setState({ snackbaropen: true, snackbarmsg: message });
                    refreshParentStudent(item);
                    this.props.onHide();
                })
                .catch((err) => {
                    console.log(err);
                    const { message } = err.response.data;
                    this.setState({ snackbaropen: true, snackbarmsg: message });
                });
        } else {
            StudentService.create(event)
                .then((response) => {
                    const { message } = response.data;
                    //alert(message)
                    this.setState({ snackbaropen: true, snackbarmsg: message });
                    refreshParentStudent(item);
                    this.props.onHide();
                })
                .catch((err) => {
                    console.log(err);
                    const { message } = err.response.data;
                    this.setState({ snackbaropen: true, snackbarmsg: message });
                });
        }



    }

    snackbarClose = (event) => {
        this.setState({ snackbaropen: false });
    }

    //<Form.Control type="hidden" name='studentId' value={item.student.id || ''}  />
    render() {
        const { item } = this.state;
        //console.log('In render : ');
        //console.log(item);
        const titre = <h2>{item.id ? 'Modifier Stagiaire' : 'Ajout Stagiaire'}</h2>;
        return (
            <div className='container'>

                <Snackbar
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                    open={this.state.snackbaropen}
                    autoHideDuration={3000}
                    onClose={this.snackbarClose}
                    message={<span id='message-id'> {this.state.snackbarmsg}  </span>}
                    action={[
                        <IconButton
                            key="close"
                            aria-label='Close'
                            color='inherit'
                            onClick={this.snackbarClose}
                        >X</IconButton>
                    ]}
                ></Snackbar>

                <Modal
                    {...this.props}
                    size="lg"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                >
                    <Modal.Header closeButton>
                        <Modal.Title id="contained-modal-title-vcenter">
                            {titre}
                        </Modal.Title>
                    </Modal.Header>
                    <Form onSubmit={this.handleSubmit}>



                        <Modal.Body>
                            <Container>

                                <Row>
                                    <Col xs={4} md={4}>
                                        <FormGroup controlId='salutation'>
                                            <Form.Label>Salutation</Form.Label>
                                            <Form.Select size="sm" aria-label="salutation" name='salutation' onChange={this.handleChange} value={item.salutation || ''} required>
                                                <option>Choisir une salutation</option>
                                                <option value="Madame">Madame</option>
                                                <option value="Monsieur">Monsieur</option>
                                            </Form.Select>
                                        </FormGroup>
                                    </Col>
                                    <Col xs={4} md={4}>
                                        <FormGroup controlId='lastName'>
                                            <Form.Label>Nom</Form.Label>
                                            <Form.Control size="sm" type="text" name='lastName' onChange={this.handleChange} value={item.lastName || ''} required placeholder='Nom' />
                                        </FormGroup>
                                        <FormGroup controlId='studentId'>
                                            <Form.Control type="hidden" name='studentId' onChange={this.handleChange} value={item.id || ''} />
                                        </FormGroup>
                                    </Col>
                                    <Col xs={4} md={4}>
                                        <FormGroup controlId='firstName'>
                                            <Form.Label>Prénom</Form.Label>
                                            <Form.Control size="sm" type="text" name='firstName' onChange={this.handleChange} value={item.firstName || ''} required placeholder='Prénom' />
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs={4} md={4}>
                                        <FormGroup controlId='email'>
                                            <Form.Label>Email</Form.Label>
                                            <Form.Control size="sm" type="text" name='email' onChange={this.handleChange} value={item.email || ''} required placeholder='Email' />
                                        </FormGroup>
                                    </Col>
                                    <Col xs={4} md={4}>
                                        <FormGroup controlId='phone'>
                                            <Form.Label>Téléphone</Form.Label>
                                            <Form.Control size="sm" type="text" name='phone' onChange={this.handleChange} value={item.phone || ''} required placeholder='Téléphone' />
                                        </FormGroup>
                                    </Col>
                                    <Col xs={4} md={4}>
                                        <FormGroup controlId='company'>
                                            <Form.Label>Entreprise</Form.Label>
                                            <Form.Control size="sm" type="text" name='company' onChange={this.handleChange} value={item.company || ''} placeholder='Entreprise' />
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs={6} md={6}>
                                        <FormGroup controlId='address'>
                                            <Form.Label>Adresse</Form.Label>
                                            <Form.Control size="sm" type="text" name='address' onChange={this.handleChange} value={item.address || ''} required placeholder='Adresse' />
                                        </FormGroup>
                                    </Col>
                                    <Col xs={3} md={3}>
                                        <FormGroup controlId='zipCode'>
                                            <Form.Label>Code Postal</Form.Label>
                                            <Form.Control size="sm" type="text" name='zipCode' onChange={this.handleChange} value={item.zipCode || ''} required placeholder='Code Postal' />
                                        </FormGroup>
                                    </Col>
                                    <Col xs={3} md={3}>
                                        <FormGroup controlId='city'>
                                            <Form.Label>Ville</Form.Label>
                                            <Form.Control size="sm" type="text" name='city' onChange={this.handleChange} value={item.city || ''} required placeholder='Ville' />
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs={12} md={12}>
                                        <FormGroup controlId='comments'>
                                            <Form.Label>Commentaires</Form.Label>
                                            <Form.Control size="sm" as="textarea" name='comments' onChange={this.handleChange} value={item.comments || ''} placeholder='Commentaires' />
                                        </FormGroup>
                                    </Col>
                                </Row>



                            </Container>


                        </Modal.Body>
                        <Modal.Footer>
                            <FormGroup>
                                <Button variant="dark" type="submit" >Enregistrer</Button>
                            </FormGroup>
                            <Button variant='danger' onClick={this.props.onHide}>Fermer</Button>
                        </Modal.Footer>
                    </Form>
                </Modal>
            </div>
        );
    }
}